import type { ComponentProps } from 'react'
import { Separator } from '@cocoonspace/ui/components/separator'
import { cn } from '@cocoonspace/ui/lib/utils'

export const HeaderWithSeparator = ({
	children,
	className,
	...props
}: ComponentProps<'header'>) => (
	<header
		{...props}
		className={cn('flex flex-row items-center gap-2 text-sm', className)}
	>
		{children}

		<Separator className='flex-1' />
	</header>
)
